import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from '@/lib/auth-client';
import { useWorkspaceStore } from '@/stores/workspace';

export function RequireAuth() {
  const { data, isPending } = useSession();
  const location = useLocation();

  if (isPending) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!data?.user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export function RequireWorkspace() {
  const workspace = useWorkspaceStore((s) => s.current);
  if (!workspace) return <Navigate to="/onboarding" replace />;
  return <Outlet />;
}
